var options = {
    'product-carousel': {
        container: '',
        mode: 'gallery',
        speed: 500,
        navAsThumbnails: true,
        navContainer: '.thumbnails',
        controlsContainer: '.controls',
        center: true,
        items: 1,
        autoplay: true,
        autoplayHoverPause: true,
        autoplayTimeout: 7000,
        autoplayButtonOutput: false,
        startIndex: (Math.floor(Math.random() * (5 - 0 + 1)) + 0),
    },
    'home-slider': {
        container: '',
        mode: 'gallery',
        speed: 500,
        controls: false,
        center: true,
        items: 1,
        autoplay: true,
        autoplayHoverPause: true,
        navPosition: 'bottom',
        autoplayTimeout: 7000,
        autoplayButtonOutput: false,
    }
};

var doc = document, sliders = new Object();

for (var i in options) {
    var item = options[i];
    item.container = '.' + i;
    if (doc.querySelector(item.container)) {
        var tns_container = i;
        sliders[i] = tns(options[i]);
    }
}

var buttons = document.querySelectorAll('.tns-nav button,.thumbnails .slide');
buttons.forEach(function() {
    this.addEventListener('click', function(e) {
        sliders[tns_container].play();
    })
});